import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = {
  key: 0,
  class: "col-12 text-center"
}
const _hoisted_3 = { class: "col-12" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "form" }
const _hoisted_6 = { class: "row justify-content-center mt-30" }
const _hoisted_7 = { class: "col-12 col-6-md" }
const _hoisted_8 = { class: "row justify-content-center text-center mt-20" }
const _hoisted_9 = { class: "col-12" }
const _hoisted_10 = {
  key: 1,
  class: "submit-success pt-30"
}
const _hoisted_11 = {
  key: 2,
  class: "pt-30"
}
const _hoisted_12 = { class: "row justify-content-center mt-30 text-center" }
const _hoisted_13 = { class: "col-12 mt-20" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_input_text = _resolveComponent("input-text")!
  const _component_checkbox = _resolveComponent("checkbox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.submitSuccess && !_ctx.submitError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("p", null, "Request a case study or simply give us a shout to see how we can support you.", -1 /* CACHED */)
        ]))]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_3, [
      (!_ctx.submitSuccess && !_ctx.submitError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("form", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_input_text, {
                    "input-type": "text",
                    name: "fullname",
                    label: "Your name",
                    placeholder: "John Smith",
                    modelValue: _ctx.fullname,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.fullname) = $event)),
                    "validation-state": _ctx.v$.fullname
                  }, null, 8 /* PROPS */, ["modelValue", "validation-state"]),
                  _createVNode(_component_input_text, {
                    "input-type": "text",
                    name: "company",
                    label: "Which business are you from?",
                    placeholder: "Business Name Ltd",
                    modelValue: _ctx.company,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.company) = $event)),
                    "validation-state": _ctx.v$.company
                  }, null, 8 /* PROPS */, ["modelValue", "validation-state"]),
                  _createVNode(_component_input_text, {
                    "input-type": "text",
                    name: "email",
                    label: "Your email address",
                    placeholder: "john.smith@business.com",
                    modelValue: _ctx.email,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event)),
                    "validation-state": _ctx.v$.email
                  }, null, 8 /* PROPS */, ["modelValue", "validation-state"]),
                  _createVNode(_component_input_text, {
                    "input-type": "text",
                    name: "telephone",
                    label: "Best number to contact you on",
                    placeholder: "07999 999999",
                    modelValue: _ctx.telephone,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.telephone) = $event)),
                    "validation-state": _ctx.v$.telephone
                  }, null, 8 /* PROPS */, ["modelValue", "validation-state"]),
                  _createVNode(_component_input_text, {
                    "input-type": "textarea",
                    name: "message",
                    label: "Your message",
                    placeholder: "Tell us a bit about your business and how we can help",
                    modelValue: _ctx.message,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.message) = $event)),
                    "validation-state": _ctx.v$.message
                  }, null, 8 /* PROPS */, ["modelValue", "validation-state"]),
                  _createVNode(_component_checkbox, {
                    name: "privacy",
                    "form-value": "yes",
                    modelValue: _ctx.privacy,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.privacy) = $event)),
                    "validation-state": _ctx.v$.privacy,
                    class: "mt-20"
                  }, {
                    default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                      _createElementVNode("span", { class: "text-xs" }, [
                        _createTextVNode("By proceeding, I agree for my personal data to be used in accordance with the "),
                        _createElementVNode("a", {
                          href: "/privacy-policy",
                          target: "_blank"
                        }, "Privacy Policy"),
                        _createTextVNode(" and to the Terms and Conditions of this website.")
                      ], -1 /* CACHED */),
                      _createElementVNode("br", null, null, -1 /* CACHED */)
                    ]))], undefined, true),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue", "validation-state"])
                ])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "button button--cta text-center",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.validate && _ctx.validate(...args)))
                  }, "Get in touch")
                ])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.submitSuccess)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[10] || (_cache[10] = [
            _createElementVNode("div", { class: "row justify-content-center mt-30 text-center" }, [
              _createElementVNode("div", { class: "col-12 col-6-md" }, [
                _createElementVNode("h4", { class: "submit-success__title" }, " Thank you for your interest. "),
                _createElementVNode("p", null, [
                  _createElementVNode("strong", null, "Someone from the regit.cars team will be in touch very shortly.")
                ])
              ])
            ], -1 /* CACHED */)
          ]))]))
        : _createCommentVNode("v-if", true),
      (_ctx.submitError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-12 col-6-md" }, [
                _createElementVNode("h4", { class: "submit-error__title" }, " Oops! Something went wrong on our end. Please try again or let us know if the problem continues. ")
              ], -1 /* CACHED */)),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button button--cta text-center",
                  onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, "Go Back")
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}